import { InputTemplate } from 'views/templates/module/inputTemplate';
import { CheckInput } from 'views/templates/module/checkInput';
import { icons } from 'constants/icons';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';
import './style.scss';

export type InvoiceInputProps = {
  textInput: any;
  checkInput: any;
  showCheckInput?: boolean;
};

export const InputInvoice = ({
  textInput,
  checkInput,
  showCheckInput = true,
}: InvoiceInputProps) => {
  return (
    <div className="inputInvoice">
      <div className="inputInvoice_row">
        <SvgIcon icon={icons.alphabetT} size={IconSize.icon_s} />
        <InputTemplate 
          type="text" 
          placeholder="半角数字13桁" 
          maxLength={13} 
          {...textInput} 
        />
      </div>
      {showCheckInput && (
        <CheckInput
          name="hasInvoice" 
          label={'インボイス番号は所持していない'} 
          {...checkInput} 
        />
      )}
    </div>
  );
};